import { blogPermissions } from '@ztechapps/blog.common'

export const NO_VIEW_PERMISSION_REASON = `You need the ${blogPermissions.canView.value} permission.`
export const NO_EDIT_PERMISSION_REASON = `You need the ${blogPermissions.canEdit.value} permission.`
export const NO_DELETE_PERMISSION_REASON = `You need the ${blogPermissions.canDelete.value} permission.`
